export default __webpack_public_path__ + "static/media/calendar.990f3db4.svg";